module.exports = __webpack_public_path__ + "img/CovidSector_Infographics_14.7800824b.png";